var FuseProgressBarModule = /** @class */ (function () {
    function FuseProgressBarModule() {
    }
    return FuseProgressBarModule;
}());
export { FuseProgressBarModule };
